

import { dashboardMap } from "./pages/dashboard/dashboard";
import { dashroutes1 } from './pages/dashboard/routes';



// Fetch config from API
async function fetchPageConfig() {
  //${home}
 const res = await fetch(`${window['apiUrl']}/api/page-config.php`);
 if (!res.ok) throw new Error("Failed to load page config");

 // Example response:
 // { dashboard: "R3", pages: ["settings"] }
 return await res.json();
}
// Dynamically build routes
export async function createRouter() {
 const config = await fetchPageConfig();

 if (config?.photos && typeof config.photos === "object") {
  Object.entries(config.photos).forEach(([key, value]) => {
   if (typeof value === "string") {
    window.localStorage.setItem(key, value);
   }
    /**
     *  window.localStorage.getItem();
     */
  });
 }

 const activeDashboard = dashboardMap[config.dashboard || "R"]; 
 // If dashboard key is invalid
 if (!activeDashboard) {
  throw new Error(`Invalid dashboard: ${config.dashboard}`);
 }
 
 const childrenRoutes = [
  activeDashboard, 
  /*{
   path: "*",
   element: (
    <div className="text-white grid justify-center items-center h-[80vh]">
     <p>404 - Page Not Found</p>
    </div>
   ),
  },*/
 ];
  let w = dashroutes1(childrenRoutes);
  //console.log(w);
  return w; //dashroutes(childrenRoutes);

  /*
 const router = createBrowserRouter(
  [
   { ...LogoutR },
   {
    path: "/",
    element: <Layout />,
    loader: loader,
    errorElement: <ErrorPage />,
    children: childrenRoutes,
   },
  ],
  {
   basename: `${base}`,
  }
 );

 return router;*/
}
